export * from './component';
export * from './crud';
export * from './emit';
export * from './form';
export * from './logout';
export * from './modal';
export * from './navigate';
export * from './notifications';
export * from './power';
export * from './register';
export * from './request';
export * from './resource';
export * from './rest';
export * from './script';
export * from './slickgrid';
export * from './base';
const CLASSMAP = {
    cache: 'CacheAction',
    clearCache: 'ClearCacheAction',
    closeModal: 'CloseModalAction',
    closeComponent: 'CloseComponentAction',
    crud: 'CRUDAction',
    emit: 'EmitAction',
    form: 'FormAction',
    logout: 'LogoutAction',
    navigate: 'NavigateAction',
    register: 'RegisterAction',
    reloadComponentData: 'ReloadComponentDataAction',
    reloadSlickgrid: 'ReloadSlickgridAction',
    request: 'RequestAction',
    resource: 'ResourceAction',
    rest: 'RestAction',
    script: 'ScriptAction',
    setData: 'SetDataAction',
    showModal: 'ShowModalAction',
    toastMessage: 'ToastMessageAction',
    notification: 'NotificationAction',
    power: 'PowerAction'
};
export function getActionClassName(name) {
    const result = CLASSMAP[name];
    if (!result) {
        throw new TypeError(`Unknown action name: ${name}`);
    }
    return result;
}
//# sourceMappingURL=index.js.map